// Phone formatting shared by the caller pop and Setup → Clevis Ring. How a
// call shows for a person (banner, corner note, or not at all) is their own
// preference on their account (UiPrefs.callerPop, My profile → Incoming calls).

/** +17025550142 → (702) 555-0142; anything else as given. */
export function fmtPhone(e164: string): string {
  const m = (e164 ?? "").match(/^\+1(\d{3})(\d{3})(\d{4})$/);
  return m ? `(${m[1]}) ${m[2]}-${m[3]}` : e164 ?? "";
}
